'use client'

import { User } from '@/domain/models'

import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from 'react'
import { deleteCookie } from '@/helpers/cookie'
import { CheckUserToken } from '@/server/controllers/users/check-token'

interface AuthContextType {
  user: User | null
  updateUser: (newUserData: User | null) => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null)

  const checkToken = async () => {
    try {
      const { data, error } = await CheckUserToken()

      if (error || !data) throw error

      setUser(data)
    } catch {
      deleteCookie(['userLogged', 'clientSelected'])

      const unloggedPaths = ['/esqueceu-senha', '/redefinir-senha']

      if (unloggedPaths.some(path => location.href.includes(path))) return

      if (!location.href.includes('/login')) location.href = '/login'
    }
  }

  useEffect(() => {
    checkToken()
  }, [])

  const updateUser = (newUserData: User | null) => {
    setUser(newUserData)
  }

  return (
    <AuthContext.Provider value={{ user, updateUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useUser = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useUser must be used within a AuthProvider')
  }
  return context
}
